import { AnalyticsAdapter } from './AnalyticsAdapter'

export const analyticsAdapter = new AnalyticsAdapter()
